import React from 'react';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import {t} from 'react-switch-lang';
import ModalBody from 'reactstrap/lib/ModalBody';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import './prompt.scss';

const TransitionModal = ({open, toggleModal, onCancel, onOk}) => {
  return (
    <Modal
      isOpen={open}
      toggle={toggleModal}
      className="modal-md modalDelete"
      backdrop="static"
    >
      <ModalHeader toggle={toggleModal}>
        <div>{t('message.warning')}</div>
      </ModalHeader>
      <ModalBody className="d-flex flex-row">
        <div>
          <div className="row">
            <div className="py-2 my-2">
              <h3>{t('message.redirectMessage')}</h3>
            </div>
            <div className="container-fluid decorationLine"></div>
            <div className="footer-btns text-right offset-5">
              <button onClick={onCancel} className="btn">
                {t('buttons.cancel')}
              </button>
              <button className="btn primary-submit" onClick={onOk}>
                OK
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TransitionModal;

// const [transitionModal, setTransitionModal] = useState(false);
//
//  <TransitionModal
//                     open={transitionModal}
//                     toggleModal={() => setTransitionModal(!transitionModal)}
//                     onCancel={() => setTransitionModal(false)}
//                     onOk={() => {
//                         setTab(2);
//                         setTransitionModal(false);
//                         setEditingMode(false)
//                     }}
//                     />
//
// onCancel samo zatvoriti modal
// onOk dozvoliti prelazak na drugi tab, vratiti formu u pocetno stanje
//
// Tabovi se dodjeljuju odredjenom state-u, napraviti funkciju koja provjerava
// da li je forma u edit mode i da li se mijenja tab
// ako jeste, otvoriti modal
// ako nije, dozvoliti prelazak
//
//
//  const toggleTab = val => {
//         if(val === 2 && editingMode === true){  // pokusaj prelaska na drugi tab u edit mode
//             setTransitionModal(true)
//         }else{
//             setTab(val)
//         }
//     };
//
